import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet } from 'react-router-dom';

import { useCustomerAuthStore } from './customerAuthStore';
import { bootstrapPortalSession } from './portalApolloClient';

export function RequireCustomerAuth(): JSX.Element {
  const { t } = useTranslation();
  const access_token = useCustomerAuthStore((s) => s.access_token);
  const [checking, setChecking] = useState(!access_token);

  useEffect(() => {
    if (access_token) return;
    let active = true;
    void bootstrapPortalSession().finally(() => {
      if (active) setChecking(false);
    });
    return () => {
      active = false;
    };
  }, [access_token]);

  if (access_token) return <Outlet />;
  if (checking) {
    return (
      <div className="text-muted-foreground flex min-h-screen items-center justify-center text-sm">
        {t('common.loading')}
      </div>
    );
  }
  return <Navigate to="/portal/login" replace />;
}
